import { merge } from 'lodash';

const initialState = {
  titulo: '',
  anoMesCorteUltimoCiclo: null /* DATABASE Laudo Blndado */,
  dataHomologacao: null,
  atualizarAte: null /* IPCA */,
  atualizarDesdeList: [
    { text: 'Data de Corte do Último Ciclo', value: 'DATA_CORTE_ULTIMO_CICLO' },
    { text: 'Data de Homologação', value: 'DATA_HOMOLOGACAO' }
  ],
  atualizarDesde: 'DATA_CORTE_ULTIMO_CICLO',
  arquivoBaixas: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false,
    fakeFile: false,
    headerValido: false
  },
  arquivoIa: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  },
  origemBaixas: 'SIMULACAO',
  simulacaoBaixas: {
    id: null,
    nome: ''
  }
};

const state = initialState;

const getters = {};

const actions = {
  setMovimentacaoBlindada({ commit }, value) {
    commit('SET_MOVIMENTACAO_BLINDADA', value);
  },
  clearMovimentacaoBlindada({ commit }) {
    commit('CLEAR_MOVIMENTACAO_BLINDADA', initialState);
  }
};

const mutations = {
  SET_MOVIMENTACAO_BLINDADA: (state, value) => (state = merge(state, value)),
  CLEAR_MOVIMENTACAO_BLINDADA: (state, value) => {
    state = merge(state, value);
    state.arquivoBaixas.fileObj = undefined;
    state.arquivoIa.fileObj = undefined;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
